import { Wrapper } from './Wrapper';

export default Wrapper;
